import React, {useEffect, useState} from 'react'
import { fetchCurrentScoupons, scouponsSelector } from '../../api/sCouponSlice'
import { addCartCoupons, qtyupdate,  cartCouponSelector } from '../../api/cartSlice'
import { brandSelector, fetchOneBrand} from '../../api/brandSlice'
import Fade from 'react-reveal/Fade'
import {  useDispatch, useSelector } from 'react-redux';
import {useParams} from 'react-router-dom'
import styled from 'styled-components'
import { Table, Space, Button, Popover , Modal} from 'antd';
import Interweave from 'interweave'
import {viewCartshowModal } from '../../api/modalSlice'
import { MdCardGiftcard, MdAddShoppingCart } from "react-icons/md";
import { BsInfoCircleFill, BsInfoCircle} from "react-icons/bs";
import { Link } from 'react-router-dom';
import Loader from '../../shared/loader'

import CartView from '../../components/social_coupons/cartView'
import {useLocation} from 'react-router-dom'

export default function Scdetail(props) {
    const dispatch = useDispatch()
    let { id } = useParams();
    const { pathname } = useLocation()
    const {cartCoupons} = useSelector(cartCouponSelector)

    const {scatgoryCoupon , loading} = useSelector(scouponsSelector)
    const {currentBrand } = useSelector(brandSelector)
    const [isVisible, setVisible] = useState(false)
    const [curr_coupon, setCoupon] = useState(null);


console.log(currentBrand)
// console.log(isVisible)


useEffect(()=>{

 dispatch(fetchCurrentScoupons(id))
 dispatch(fetchOneBrand(id))

}, [dispatch])


const onAdd = (id, data) =>{
  
 console.log(id, data);

dispatch(addCartCoupons(data))

}


const increment = (id) =>{

    let data = {id, incr:'incr'}
  
    dispatch(qtyupdate(data))
    
  
  }
  
  const decrement = (id) =>{
  
    let data = {id, decr:'decr'}
   
    dispatch(qtyupdate(data))
  
  
  
  }

  const handleModalClick = (e, isvisible, id) =>{

    e.preventDefault()
    setCoupon(id)
    setVisible(isvisible)
    }

    useEffect(()=>{

        if(pathname === "/checkout"){
      
           return dispatch(viewCartshowModal(false))
          
          }
      
      
      })

const columns = [
  
{

    title:'E-voucher',
   
    render: (text, record)=>(

     <span className=" flex justify-start items-center  text-center text-dark">

         <MdCardGiftcard className="text-orange-500 text-[30px]  p-1 bg-[#343A40] text-center"/>&nbsp; <small className="ml-2">{record.name}</small> </span>
    ),
    key:'E-voucher'
},
        {
            title: 'Value',
            dataIndex: 'value',
            render:(value)=>{
console.log({V:value});
           return <small>&#x20B9;&nbsp;{value}</small>
            },
            key: 'Value',
          },
          
        // {
        //     title: 'Validity',
        //     dataIndex: 'validity',
        //     key: 'Validity',
        //   },
    

          {
              tital:'Action',
              dataIndex:'Action',
              render:(text, record)=>{
           
                const exist = cartCoupons.findIndex((item) => item._id === record._id);
                return <div className="flex items-center">
                  {
                      (exist === -1)?   
                      <button  onClick={()=>onAdd(text, record)} className="md:text-[16px] text-[8px] flex px-3 py-[6px] rounded-md items-center "  style={{backgroundColor:'white', border:'1px solid #9a4c9d', color:'#9a4c9d'}}>
                      <MdAddShoppingCart className="text-[#9a4c9d] text-[20px]"/>&nbsp;
                  
                        <small>Add Cart </small>

                    </button> : <Fade >  <Space className='md:block flex '>
                     <div className='flex space-x-0 md:space-x-2'>
                     <Button disabled={(exist !== -1) && cartCoupons[exist].qty === 1 ? true : false}  type="primary"  onClick={()=>decrement(record._id)}>-</Button>
                    <Button className='w-2 ' >{(exist !== -1) && cartCoupons[exist].qty}</Button>
                    <Button type="primary" onClick={()=>increment(record._id)}>+</Button>
                    </div>
        
                   </Space></Fade>
                
                  }{
                    (exist === -1)? <h5 onClick={(e)=>handleModalClick(e, true, record)} className="text-secondary  m-0">
                    <BsInfoCircleFill className="ml-4 text-[#9a4c9d] text-[16px] cursor-pointer  " />                    
                    </h5>:<></>
                  }
    
                    {/* <h5 onClick={(e)=>handleModalClick(e, true, record)} className="text-secondary  m-0">
                    <BsInfoCircleFill className="ml-4 text-[#9a4c9d] text-[16px] cursor-pointer  " />                    
                    </h5> */}

                  {/* <Popover content={record.terms} title="Info" trigger="click">
                  <BsInfoCircleFill className="ml-4 info " style={{cursor:"pointer"}} />
                    </Popover> */}
                 </div> 

              }
          },

]


if(loading) {

    return <Loader/>

}

    return (
        <div className='' style={{minHeight:"80vh"}}>
        {/* <ScDetailWrap className="container my-5" style={{minHeight:"70vh"}}> */}
            <div className="container md:flex   md:h-80 h-[240px]  md:py-12 py-4 mx-auto lg:w-4/5 block ">
                <div className="my-3 md:w-[255px] w-[310px]  md:mx-6 mx-12   border-white rounded-3xl  z-80 md:shadow-2xl shadow-xl ">
                   <img src={currentBrand && currentBrand.image}  className="md:my-[24px] my-[4px] h-[140px]  object-cover w-full "  alt="imglogo" />

                  <h5 className="bg-[#9a4c9d] text-center rounded-b-3xl   text-white md:pt-3 pt-3 mb-0 text-[16px]  md:h-12 h-12 " >{currentBrand && currentBrand.name}</h5>
                  {/* <hr /> */}

                </div>
                <div className="w-[90%] md:pt-3 pt-2 ">


                <Table  columns={columns}
                
                expandable={{
                expandedRowRender: (record, index) =><div > <p style={{ margin: 0 }}>{record.brand.description}</p></div>,
                    rowExpandable: record => record.name !== 'Not Expandable',
                  }}
                  rowKey={(record)=> record._id}
              
                dataSource={scatgoryCoupon } />
                <Link to={'/cart'}>
                <Button type='primary' 
         style={{backgroundColor:'white', border:'1px solid #9a4c9d ', color:'#9a4c9d', fontSize:"1rem", float:"right", clear:"left"}}
          >
          View Cart
       </Button>
       </Link>

                </div>
            
            </div>

       
            <Modal 
                width="45%"
                title="Terms and Conditions"
                footer={false}
                className=""
                visible={isVisible}
                onCancel={()=>setVisible(!isVisible)}>
                    <div className="px-4">
                    <Interweave content={curr_coupon?.brand?.terms }/>
                        </div>                

                </Modal> 
        {/* </ScDetailWrap> */}
              
        </div>
    )
}




const ScDetailWrap = styled.div`

.voucher{

color:orange;
font-size:1.9rem;

}

.addcart{

    color:#9a4c9d;
    font-size:1.2rem;

}

.info{
    color:#9a4c9d;
    font-size:1rem;
}



hr{
    height:0.2rem;
    background-color:orange;
    width:50%;
    margin:0.2rem auto;
    
}

.action{
    display:flex;
    align-items:center;
}

.addCart{

    display:flex;
    align-items:center;
    justify-content:space-around;
     li{

         list-style:none;
         text-align:center;

     }


     
}


`